class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('.product-tabs__item'));
    this.mql = window.matchMedia('(min-width: 750px)');
  }

  connectedCallback() {
    if (this.items.length < 2) return;
    this.buildNav();
    this.classList.add('product-tabs--enhanced');
    this.onChange = () => this.applyMode();
    this.mql.addEventListener('change', this.onChange);
    this.applyMode();
  }

  disconnectedCallback() {
    if (this.onChange) this.mql.removeEventListener('change', this.onChange);
  }

  buildNav() {
    this.nav = document.createElement('div');
    this.nav.className = 'product-tabs__nav';
    this.nav.setAttribute('role', 'tablist');

    this.buttons = this.items.map((item, i) => {
      const labelEl = item.querySelector('.product-tabs__summary-text');
      const panel = item.querySelector('.product-tabs__panel');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-tabs__tab';
      btn.textContent = labelEl ? labelEl.textContent.trim() : `Tab ${i + 1}`;
      btn.id = `${item.id}-tab`;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', panel ? panel.id : '');
      if (panel) {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', btn.id);
      }
      btn.addEventListener('click', () => this.select(i, true));
      btn.addEventListener('keydown', (e) => this.onKeydown(e, i));
      this.nav.appendChild(btn);
      return btn;
    });

    this.prepend(this.nav);
  }

  applyMode() {
    if (this.mql.matches) {
      // Tab mode: exactly one panel open.
      let active = this.items.findIndex((it) => it.open);
      if (active < 0) active = 0;
      this.select(active, false);
    } else {
      // Accordion mode: let native <details> behave; reset roving tabindex.
      this.buttons.forEach((b) => {
        b.setAttribute('aria-selected', 'false');
        b.tabIndex = -1;
      });
    }
  }

  select(index, focus) {
    this.items.forEach((item, i) => {
      const on = i === index;
      item.open = on;
      item.classList.toggle('product-tabs__item--active', on);
      this.buttons[i].setAttribute('aria-selected', on ? 'true' : 'false');
      this.buttons[i].tabIndex = on ? 0 : -1;
    });
    if (focus) this.buttons[index].focus();
    this.active = index;
  }

  onKeydown(e, i) {
    const n = this.items.length;
    let next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next !== null) {
      e.preventDefault();
      this.select(next, true);
    }
  }
}

customElements.define('product-tabs', ProductTabs);
